import { AccountInvitation } from '../../../modules/users/invitations/types';
import { Role } from '../../../modules/users/roles/types';
import { AccountStatus, SortableAccountColumns, SortOrders, Account } from '../../../modules/users/types';
import { UserAccount } from './types';

type SortAble = string | number | Date;

const sort = (sortOrder: SortOrders, a?: SortAble, b?: SortAble): number => {
  const sortDirection = (sortOrder === 'desc' ? -1 : 1 );
  let sortValue = 0;
  if (a && b) {
    sortValue = a > b ? 1 : a < b ? -1 : 0;
  } else if (a) {
    sortValue = -1;
  } else {
    sortValue = 1;
  }
  return sortValue * sortDirection;
};

export const isUser = (user: UserAccount): user is Account => {
  return ('lastLogin' in user);
};

export const sortUserAccounts = (sortBy: SortableAccountColumns, sortOrder: SortOrders, users: Account[], userInvitations: AccountInvitation[], roleData: Role[]): UserAccount[] => {
  const userAndInvitationSortableColumns = ['email'];
  let accounts: UserAccount[] = [];
  // we can do normal sort for columns
  // which will be present in both user and invitations
  if (userAndInvitationSortableColumns.some((column) => column === sortBy)) {
    accounts = [...users, ...userInvitations];
    accounts.sort((a, b) => {
      return sort(sortOrder, a[sortBy], b[sortBy]);
    });
  } else {
    switch (sortBy) {
      case 'role': {
        accounts = [...users, ...userInvitations];
        accounts.sort((a, b) => {
          return sort(
            sortOrder,
            roleData?.find(role => role.id === a.roleId)?.roleName || 'User',
            roleData?.find(role => role.id === b.roleId)?.roleName || 'User',
          );
        });
        break;
      }
      // There are different default status
      // for users and invitations, sorting according to that
      case 'status': {
        accounts = [...users, ...userInvitations];
        accounts.sort((a, b) => {
          return sort(
            sortOrder,
            isUser(a) ? a.status : AccountStatus.invitation_sent,
            isUser(b) ? b.status : AccountStatus.invitation_sent,
          );
        });
        break;
      }
      // Since the first sorting action for 'name' is ascending,
      // need to consider N/A oldest
      case 'name': {
        accounts = [...users, ...userInvitations];
        accounts.sort((a, b) => {
          return sort(
            sortOrder,
            !a.firstName && !a.lastName ? undefined : `${a.firstName} ${a.lastName}`,
            !b.firstName && !b.lastName ? undefined : `${b.firstName} ${b.lastName}`,
          );
        });
        break;
      }
      // These will be the cases for  'lastLogin' | 'signupDate'
      // since the first sorting action for them is descending,
      // need to consider N/A as earliest
      default: {
        accounts = sortOrder === 'asc'
          ? [...userInvitations, ...users]
          : [...users, ...userInvitations];
        break;
      }
    }
  }
  return accounts;
};